// extracted by css-extract-rspack-plugin
export default {"iconFallback":"od00Uj"};